var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustbinPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 3.60294H11.6663M5.83301 9.77941V6.07353M8.16634 9.77941V6.07353M9.33301 12.25H4.66634C4.02201 12.25 3.49967 11.6969 3.49967 11.0147V4.22059C3.49967 3.87947 3.76084 3.60294 4.08301 3.60294H9.91634C10.2385 3.60294 10.4997 3.87947 10.4997 4.22059V11.0147C10.4997 11.6969 9.97734 12.25 9.33301 12.25ZM5.83301 3.60294H8.16634C8.48851 3.60294 8.74967 3.32641 8.74967 2.98529V2.36765C8.74967 2.02653 8.48851 1.75 8.16634 1.75H5.83301C5.51084 1.75 5.24967 2.02653 5.24967 2.36765V2.98529C5.24967 3.32641 5.51084 3.60294 5.83301 3.60294Z",
    stroke: "#CD0000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbinPortfolio);
export default __webpack_public_path__ + "static/media/dustbinPortfolio.63d0f5eec95ccff624bbf068a0b7f5af.svg";
export { ForwardRef as ReactComponent };